/** Note on selectors:
 * If your selector contains multiple selectors separated by a comma,
 * then you should write your selector as a function, passing in the
 * root element as an argument that gets applied to each comma-separated
 * selector. Otherwise, prefixing the selector in code with `&${mySelector}`
 * will not be applied correctly.
 */

export const disabledSelector = (rootElement: string = '') =>
  `${rootElement}[aria-disabled="true"], ${rootElement}[disabled="true"], ${rootElement}[data-disabled="true"]`;

export const activeSelector = `:active:not(${disabledSelector()})`;

export const errorSelector = '[data-error="true"]:not([data-disabled="true"])';

export const focusedSelector = '[data-focused="true"]';

export const focusWithinSelector =
  ':focus-within:not([aria-disabled="true"], [disabled="true"])';

export const hoverSelector =
  ':hover:not([aria-disabled="true"], [disabled="true"], [data-error="true"], :active, [aria-pressed="true"])';

export const nonErrorFocusedSelector =
  '[data-focused="true"]:not([data-error="true"])';

export const selectors = {
  active: activeSelector,
  disabled: disabledSelector,
  error: errorSelector,
  focused: focusedSelector,
  focusWithin: focusWithinSelector,
  hovered: hoverSelector,
  nonErrorFocused: nonErrorFocusedSelector,
} as const;
